import React from "react";

import {
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Slide,
  Button,
  ButtonGroup,
  Typography,
  IconButton
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { NeoGraph } from "../Neograph";
import { Close } from "@mui/icons-material"; 
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// interface i_cred {
//   password: string;
//   url: string;
//   username: string;
// }

interface i_neo4j {
  // cypher: string;
  show: boolean;
  setShow: any;
  data: any;
  // creds: i_cred;
  // db_name: string;
  // instrcutions: string;
}

const Neo4jPreviewModal = ({
  // cypher,
  show,
  data,
  setShow,
}: // db_name,
// instrcutions,
// creds,
i_neo4j) => {
  const [showData, setShowData] = React.useState<number>(0);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  return (
    <Dialog
      open={show}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        setShow(false);
      }}
      aria-describedby="alert-dialog-slide-description"
      fullWidth={true}
      maxWidth={"lg"}
    >
             <IconButton
        aria-label="close"
        onClick={()=> setShow(false)}
        size="small"
        sx={{
          position: 'absolute',
          right: 2,
          top: 2,
      
        }}
      >
        <Close sx={{color : "gray"}}  fontSize="small"/>
      </IconButton>
      <DialogContent sx={{ p: 4 }}>
        <Grid container justifyContent="center">
          <ButtonGroup
            variant="contained"
            aria-label="Basic button group"
            sx={{
              mb: 2,
            }}
          >
            {["Details", "Schema", "Data"].map((arr, i) => (
              <Button
                variant={showData === i ? "contained" : "outlined"}
                onClick={() => setShowData(i)}
                key={i}
              >
                {arr}
              </Button>
            ))}
          </ButtonGroup>
        </Grid>
        <Grid
          sx={{
            maxHeight: "50vh",
            overflowY: "auto",
          }}
        >
          {showData === 0 ? (
            <Grid container>
              <Grid container my={1}>
                <Typography fontWeight="bold" color="primary">
                  Database Name:
                </Typography>{" "}
                &nbsp;
                <Typography>{data?.db_name}</Typography>
              </Grid>
              <Grid container my={1}>
                <Typography fontWeight="bold" color="primary">
                  Cypher:
                </Typography>
                &nbsp;
                <Typography>{data?.cypher}</Typography>
              </Grid>
              <Grid container my={1}>
                <Typography fontWeight="bold" color="primary">
                  Instructions:
                </Typography>
                &nbsp;
                <Typography>{data?.instrcutions}</Typography>
              </Grid>
            </Grid>
          ) : showData === 1 ? (
            <NeoGraph
              width={"100%"}
              height={`350`}
              containerId={"id1"}
              neo4jUri={data?.creds?.url?.replace("+ssc", "")}
              neo4jUser={data?.creds?.username}
              neo4jPassword={data?.creds?.password}
              backgroundColor={"#fff"}
              cypher={"call db.schema.visualization"}
              alertWidth="97.5%"
            />
          ) : (
            <NeoGraph
              width={"100%"}
              height={`350`}
              containerId={"id1"}
              neo4jUri={data?.creds?.url?.replace("+ssc", "")}
              neo4jUser={data?.creds?.username}
              neo4jPassword={data?.creds?.password}
              backgroundColor={"#fff"}
              cypher={"match p = (n)-[r]-(m)-[s]-(q) return p limit 100"}
              alertWidth="97.5%"
            />
          )}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default Neo4jPreviewModal;
